"use client";
import { useContext } from "react";
import { StateContext } from "@/contexts/StateContext";

export default function useStateData() {
  const context = useContext(StateContext);

  if (!context) {
    throw new Error("useStateData must be used within a StateContextProvider");
  }

  return context;
}
